<router-outlet />
<app-toast-container />
<app-version-panel />
